import { z } from "zod";
import { ServerChatMessage } from "@/components/common/section-components/chat/chat-message.types";

export interface SellOrderEntity {
  id: number;
  fechaCreacion: string;
  titular: string;
  monto: number;
  tipoFijacion: string;
  toneladas: number;
  precioFinal: number
  estadoDescripcion: string;
  grano: string;
  sinBase: boolean;
}

export interface SellOrderDetail {
  id: number;
  montoSolicitado: number;
  saldoActual: number;
  control: boolean;
  fechaSolicitud: string;
  cuentaOrigen: number;
  sucursal: string;
  solicitante: string;
  estado: string;
  mensajes: ServerChatMessage[];
  titular: string;
  esCanje: boolean;
  grano: string;
  cosecha: string;
  tipoFijacion: string;
  toneladas: number;
  precioFinal: number
  sinBase: boolean
  mensajesDisponibles?: number;
}

export interface GranoEntity {
  id: number;
  nombre: string;
}

export interface AvailableHarvestEntity {
  cosecha: string;
  disponible: number;
}

export const sellOrderSchema = z.object({
  account: z.any().optional(),
  fixation_type: z.any().optional(),
  grain: z.any().optional(),
  harvest: z.any().optional(),
  ton: z.any().optional(),
  price: z.any().optional(),
  isExchange: z.boolean().optional().nullish(),
  order_detail: z.any().optional(),
  available_ton: z.any().optional(),
});
